module.exports = __webpack_public_path__ + "static/media/Mapa-Goiás.928706c6.svg";